import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { ISharedWithMeContentInfo } from '../../../../ts/models/ISharedWithMeContentInfo';
import { shareContent } from '../../../actions/spaces/ShareContentAction';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { anyItemIsEmbeddedDatasource } from './IEntityActionHelpers';

export const ShareContentAction: IEntityAction<IContentInfo, {}> = {
  name: EntityActionNames.ShareContent,
  translateName: Messages.share_content_action,
  isVisible: (targetItems: IContentInfo[]) => {
    const containsACollection: boolean = (targetItems.filter(item => item.contentType === 'collection')).length > 0;
    if (containsACollection && !FeatureFlags.shareCollectionsEnabled) {
      return false;
    }
    return FeatureFlags.newShareDialogEnabled && !anyItemIsEmbeddedDatasource(targetItems);
  },
  isClickable: () => true,
  createReduxAction: (targetItems: IContentInfo[]) => {
    return shareContent(targetItems[0]);
  }
};
